Vue.component('sentiment-category', {
	props: ['sentiment', 'category', 'team_id'],

	methods: {
		openCategory() {
			let params = this.getOriginalReviewFilters()

			params.sentimentCategory = this.category

			this.$eventHub.$emit('updateAndOpenModal', this.team_id, params, true)
		}
	},

	computed: {
		scoreClass() {
			if ( this.sentiment.average >= 65 ) {
                return 'success'
            } else if (this.sentiment.average >= 45) {
                return 'warning'
            } else {
                return 'danger'
            }
		}
	}
})